/* tslint:disable */
/* eslint-disable */

/**
 * 1 = One
 * 
 * 2 = Sixty
 * 
 * 3 = OneHundred
 * 
 * 4 = ThreeThousand
 * 
 * 5 = Other
 * 
 * 6 = Ninety
 */
export enum MachineRating {
  One = 1,
  Sixty = 2,
  OneHundred = 3,
  ThreeThousand = 4,
  Other = 5,
  Ninety = 6
}
